module.exports = __webpack_public_path__ + "img/stock0.d38e4969.png";